import { 
	addDoc,
	deleteDoc,
	updateDoc,
	onSnapshot
 } from "firebase/firestore"

import {
	getCollectionRef,
	getDocumentRef,
	uploadFile
} from "../utils/index.js"

const getContacts = async (localState = (data) => {}) => {

	const contactsCollectionRef = getCollectionRef("contacts")

	// get realtime contacts
	onSnapshot(contactsCollectionRef, (snapshot) => {

		// get all contacts
		const allContacts = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }))

		// store contact on locale state
		localState(allContacts)
	})
}


const addContact = async (datas) => { //factorisation function

	const {
		firstName,
		lastName,
		email,
		subject,
		message,
		file
	} = datas

	const contactsCollectionRef = getCollectionRef("contacts")

	const docRef = await addDoc(contactsCollectionRef, {
		firstName,
		lastName,
		email,
		subject,
		message,
		file,
		isRegister: false
	})

	return{ data: docRef.id }
}

const createContact = async (datas, onSetDocumentUrl, onSetProgress, onSetError) => {

	// if is no file, just send contact on firebase
	if(!datas.file){
		try{

			const result = await addContact(datas)
			return result

		}catch(err){
			return { error: err }
		}
	}

	// if is file in datas, first upload file and send contact on firebase
	try{
		const result2 = await addContact(datas)

		return { data: result2 }
	}catch(err){
		console.log(err)
	}
}

const deleteContact = async (idContact) => {

	// contact reference
	const contactDocumentRef = getDocumentRef("contacts", idContact)

	try{
		const docRef = await deleteDoc(contactDocumentRef, idContact)
		return{ data: true }
	}catch(err){
		return { error: err }
	}
}

const registerContact = async (idContact) => {

	// contact reference
	const contactDocumentRef = getDocumentRef("contacts", idContact)

	try{
		// update registed contact
		await updateDoc(contactDocumentRef, {
			isRegister: true
		})
		return{ data: true }
	}catch(err){
		return { error: err }
	}
}


export {
	getContacts,
	createContact,
	deleteContact,
	registerContact
}